/*
 * - Exposes class and methods to interact with the Project API
 */

import request, { REQUEST_METHODS } from '@api/Request';
import { ProjectEndpoints } from './config';
import {
  GetSharedContactResponse,
  GetExistingProjectsResponse,
  GetProjectLocationResponse,
  GetAllowedRequestTypesResponse,
} from './types';

export default class ProjectService {
  public static readonly getSharedContacts = (
    projectId: number,
    requestId: number,
    version: number
  ): Promise<GetSharedContactResponse> =>
    request({
      url: ProjectEndpoints.getSharedContacts(),
      method: REQUEST_METHODS.GET,
      params: { projectId, requestId, version },
    });

  public static readonly getExistingProjectsBasicInfo = (): Promise<GetExistingProjectsResponse> =>
    request({
      url: ProjectEndpoints.getExistingProjectsBasicInfo(),
      method: REQUEST_METHODS.GET,
    });

  public static readonly getProjectLocationData = (
    projectId: number,
    projectVersion?: number
  ): Promise<GetProjectLocationResponse> => {
    const params = {
      projectId,
      ...(projectVersion !== undefined ? { projectVersion } : {}),
    };

    return request({
      url: ProjectEndpoints.getProjectLocationData(),
      method: REQUEST_METHODS.GET,
      params,
    });
  };

  public static readonly getAllowedRequestTypes = ({
    state,
    district,
  }: {
    state?: string;
    district?: string;
  }): Promise<GetAllowedRequestTypesResponse> => {
    const params = {
      ...(state ? { state } : {}),
      ...(district ? { district } : {}),
    };
    return request({
      url: ProjectEndpoints.getAllowedRequestTypes(),
      method: REQUEST_METHODS.GET,
      params,
    });
  };
}
